if(window.location.href.indexOf("tandem.dev") > -1) {
    document.write('<script src="http://' + (location.host || 'localhost').split(':')[0] +
        ':35729/livereload.js?snipver=1"></' + 'script>');
}
let moDevices = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4));
window.isMobile = moDevices; //initiate as false
import $ from 'jquery';
import Pikaday from 'pikaday';
import 'pikaday/plugins/pikaday.jquery';
import 'jquery.scrollbar/jquery.scrollbar.min';

window.$ = $;
window.Pikaday = Pikaday;

// function getInscribedArea(oW, oH, iW, iH, R){
//     if(!R && iW < oW && iH < oH){
//         return {
//             "h": iH,
//             "w": iW
//         };
//     }
//     if((oW / oH) > (iW / iH)){
//         return {
//             "h": oH,
//             "w": Math.round(oH * iW / iH)
//         }
//     } else {
//         return {
//             "h": Math.round(oW * iH / iW),
//             "w": oW
//         };
//     }
// }


let $header = $('header'),
    $mainwrap = $('.mainwrap');
$('.mainwrap').on('scroll',function () {
    let offsetLeft =   $mainwrap.scrollLeft(),
        offsetTop = $(document).scrollTop();

    if(offsetTop > $header.height()){
        offsetTop = offsetTop - $header.height();
        $('#links_admin').css({'transform':'translate3d('+offsetLeft+'px,'+(offsetTop)+'px,0)'})
        // $('.tandemDatePickerFormWarp').css({'transform':'translate3d('+offset +'px,0,0)'})
    }
    $('#links_admin').css({'transform':'translate3d('+offsetLeft+'px,'+(offsetTop)+'px,0)'})
    // $('.tandemDatePickerFormWarp').css({'transform':'translate3d('+offset +'px,0,0)'})
});
$(document).on('scroll',function () {
    let offsetleft =   $mainwrap.scrollLeft(),
        offsteTop = $(document).scrollTop();
    if(offsteTop > $header.height()){
        $('#links_admin').css({'transform':'translate3d('+offsetleft+'px,'+(offsteTop - $('header').height())+'px,0)'})
        // $('.tandemDatePickerFormWarp').css({'transform':'translate3d('+offset +'px,0,0)'})
    }else{
        $('#links_admin').css({'transform':'translate3d('+offsetleft+'px,'+0+'px,0)'})
    }
});

$(document).ready(function(){

    if($('.touren_overview_fahrer').length < 1){
        require('./fahrer_bem_ajax.js');
        if(isMobile){
            require('./mobile_state');
        }
    }
    require('./interntemplatescript');

    setTimeout(function () {
        console.log($('#fahrerTafelTable #fahreTR0').height() );
        $('#fahrerAuswahlTable .zelle_datum').css({
            'height': ($('#fahrerTafelTable #fahreTR0').height() + $('#fahrerTafelTable .abwesend-zeile-info').height())
        })
    },1000);

    $('#links_admin').on('click','#datumVon',function(){
        console.log('yo');
        $(this).pikaday({
            format: 'DD.MM.YYYY'
        });
    });
    $('#fahrerAuswahlTable > tbody > tr > div').remove();
    $('#links_admin').on('click','#datumBis',function(){
        console.log('yo');
        $(this).pikaday({
            format: 'DD.MM.YYYY'
        });
    });

    if($('#dispotafel').length > 0){
        var scroller = $('<div class="external-scroll_x"><div class="scroll-element_outer"><div class="scroll-element_size"></div><div class="scroll-element_track"></div><div class="scroll-bar"></div></div></div>');
        $('#links_admin').append(scroller);
        // $('.user-disponent').addClass('scrollbar-vista')
        $('main').scrollbar({
            "autoUpdate":true,
            "autoScrollSize": false,
            "ignoreMobile":true,
            "scrollStep":30,
            "scrollx": $('.external-scroll_x'),
            // "stepScrolling": false
        });

    }
    //$('.scroll-wrapper').height($(window).height()-$('.mainwrap > header').height());
    console.log(isMobile);


});



// WEBPACK FOOTER //
// ./js/index.js